import { useEffect, useState } from 'react'

type Options = {
  delayMs?: number
}

export function useDebouncedValue<T>(value: T, options?: Options): T {
  const delayMs = options?.delayMs ?? 250
  const [debouncedValue, setDebouncedValue] = useState<T>(value)

  useEffect(() => {
    const timeoutId = window.setTimeout(() => {
      setDebouncedValue(value)
    }, delayMs)

    return () => window.clearTimeout(timeoutId)
  }, [delayMs, value])

  return debouncedValue
}
